<template>
  <v-card flat>
    <v-card-text class="pa-0">
      <div class="d-flex justify-end px-4 pt-3">
        <v-btn small color="primary" outlined @click="toggleDisplayUnit">
          單位: {{ displayUnit === "hours" ? "小時" : "天" }}
          <v-icon small class="ml-1">mdi-swap-horizontal</v-icon>
        </v-btn>
      </div>

      <v-simple-table>
        <template v-slot:default>
          <thead>
            <tr>
              <th class="text-left">員工姓名</th>
              <th class="text-left">類型</th>
              <th class="text-left">假別</th>
              <th class="text-left">開始時間</th>
              <th class="text-left">結束時間</th>
              <th class="text-left">請假({{ unitText }})</th>
              <th class="text-left">事由</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="item in records" :key="item.id">
              <td>{{ item.user ? item.user.name : "-" }}</td>
              <td>{{ item.type === 1 ? "使用" : "新增" }}</td>
              <td>
                {{ item.leaveTypeInfo ? item.leaveTypeInfo.name : "未知假別" }}
              </td>
              <td>{{ formatTime(item.start_time) }}</td>
              <td>{{ formatTime(item.end_time) }}</td>
              <td>{{ formatMinutes(item.leave_minutes) }}</td>
              <td>{{ item.reason || "-" }}</td>
            </tr>
          </tbody>
        </template>
      </v-simple-table>

      <div
        v-if="loading && records.length === 0"
        class="d-flex justify-center py-4"
      >
        <v-progress-circular
          indeterminate
          color="primary"
        ></v-progress-circular>
      </div>

      <div
        v-if="!loading && records.length === 0"
        class="text-center py-8 grey--text"
      >
        沒有資料
      </div>

      <div class="text-center my-4">
        <v-pagination
          v-model="page"
          :length="pageCount"
          @input="fetchRecords"
          prev-icon="fa fa-angle-left"
          next-icon="fa fa-angle-right"
          color="#cb0c9f"
          circle
        ></v-pagination>
      </div>
    </v-card-text>
    <info-dialog
      :visible.sync="showInfoDialog"
      :title="infoDialogTitle"
      :message="infoDialogMessage"
    />
  </v-card>
</template>

<script>
import InfoDialog from "@/components/Common/InfoDialog.vue";
import { formatDateTime } from "@/utils/time";

export default {
  name: "UserLeaveHistoryWidget",
  components: {
    InfoDialog,
  },
  props: {
    selectedCompany: {
      type: Object,
      default: () => null,
    },
  },
  data() {
    return {
      records: [],
      page: 1,
      itemsPerPage: 15,
      totalItems: 0,
      loading: false,
      fetchError: false,
      showInfoDialog: false,
      infoDialogTitle: "",
      infoDialogMessage: "",
      totalPages: 1,
      displayUnit: localStorage.getItem("leave_duration_unit") || "hours",
    };
  },
  computed: {
    pageCount() {
      return this.totalPages || 1;
    },
    unitText() {
      return this.displayUnit === "hours" ? "小時" : "天";
    },
  },
  watch: {
    selectedCompany: {
      handler() {
        this.page = 1;
        this.fetchRecords();
      },
      deep: true,
    },
  },
  async mounted() {
    await this.fetchRecords();
    window.addEventListener(
      "leave-duration-unit-changed",
      this.syncDisplayUnit
    );
  },
  beforeDestroy() {
    window.removeEventListener(
      "leave-duration-unit-changed",
      this.syncDisplayUnit
    );
  },
  methods: {
    formatTime(val) {
      return formatDateTime(val);
    },
    syncDisplayUnit() {
      this.displayUnit = localStorage.getItem("leave_duration_unit") || "hours";
    },
    toggleDisplayUnit() {
      this.displayUnit = this.displayUnit === "hours" ? "days" : "hours";
      localStorage.setItem("leave_duration_unit", this.displayUnit);
      window.dispatchEvent(new Event("leave-duration-unit-changed"));
    },
    formatMinutes(minutes) {
      if (minutes == null) return "0";
      const val = parseFloat(minutes);
      if (isNaN(val)) return "0";
      if (this.displayUnit === "hours") {
        const hours = val / 60;
        return Number.isInteger(hours) ? hours.toString() : hours.toFixed(1);
      }
      const days = val / 480;
      return Number.isInteger(days) ? days.toString() : days.toFixed(1);
    },
    async fetchRecords() {
      this.loading = true;
      this.records = [];
      this.fetchError = false;
      console.log("history");
      try {
        const companyId = this.selectedCompany ? this.selectedCompany.id : null;
        if (!companyId) {
          this.records = [];
          return;
        }

        const params = new URLSearchParams({
          page: this.page,
          limit: this.itemsPerPage,
          company_id: companyId,
          approval_status: "審核通過",
        });

        const response = await this.$axios.get(`/api/leave-records?${params}`);
        const data = response.data;

        const newItems = data.data || [];
        const pagination = data.pagination || {};

        this.totalItems = pagination.totalItems || 0;
        this.totalPages = pagination.totalPages || 1;

        this.records = newItems;
      } catch (error) {
        console.error("Fetch leave history error:", error);
        this.showInfoDialog = true;
        this.infoDialogTitle = "Error";
        this.infoDialogMessage = "無法取得資料";
        this.fetchError = true;
      } finally {
        this.loading = false;
      }
    },
    // Public method to force refresh
    refresh() {
      this.page = 1;
      this.fetchRecords();
    },
  },
};
</script>

<style scoped>
/* Add any specific styles here */
</style>
